import { markRaw } from 'vue';

import IconAudienceSegmentAutoEnthusiasts from '@/common/icons/audience-segments/AutoEnthusiasts';
import IconAudienceSegmentBlueCollar from '@/common/icons/audience-segments/BlueCollar';
import IconAudienceSegmentBusinessPeople from '@/common/icons/audience-segments/BusinessPeople';
import IconAudienceSegmentFashionistas from '@/common/icons/audience-segments/Fashionistas';
import IconAudienceSegmentHipsters from '@/common/icons/audience-segments/Hipsters';
import IconAudienceSegmentMusicFans from '@/common/icons/audience-segments/MusicFans';
import IconAudienceSegmentShoppers from '@/common/icons/audience-segments/Shoppers';
import IconAudienceSegmentSportFans from '@/common/icons/audience-segments/SportFans';
import IconAudienceSegmentStudents from '@/common/icons/audience-segments/Students';
import IconAudienceSegmentTourists from '@/common/icons/audience-segments/Tourists';

export default class PredefinedSegments {
  static options() {
    const options = [
      {
        name: 'Auto Enthusiasts',
        icon: markRaw(IconAudienceSegmentAutoEnthusiasts),
        index: 0.03243,
      },
      {
        name: 'Blue Collar',
        icon: markRaw(IconAudienceSegmentBlueCollar),
        index: 0.0452456,
      },
      {
        name: 'Business People',
        icon: markRaw(IconAudienceSegmentBusinessPeople),
        index: 0.09389237,
      },
      {
        name: 'Fashionistas',
        icon: markRaw(IconAudienceSegmentFashionistas),
        index: 0.0244534,
      },
      {
        name: 'Hipsters',
        icon: markRaw(IconAudienceSegmentHipsters),
        index: 0.2789,
      },
      {
        name: 'Music Fans',
        icon: markRaw(IconAudienceSegmentMusicFans),
        index: 0.1343509,
      },
      {
        name: 'Shoppers',
        icon: markRaw(IconAudienceSegmentShoppers),
        index: 0.2198304,
      },
      {
        name: 'Sport Fans',
        icon: markRaw(IconAudienceSegmentSportFans),
        index: 0.2198304,
      },
      {
        name: 'Students',
        icon: markRaw(IconAudienceSegmentStudents),
        index: 0.1324394,
      },
      {
        name: 'Tourists',
        icon: markRaw(IconAudienceSegmentTourists),
        index: 0.032458,
      },
    ];
    return options;
  }
}
